import { useApp, AppProvider } from './context/AppContext';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import AppLayout from './router/AppLayout';
import { PageSignIn } from './pages/auth/PageSignIn';
import { PageSignUp } from './pages/auth/PageSignUp';
import { PageSetupPassword } from './pages/auth/PageSetupPassword';
import { Toast } from './components/shared';
import './styles/main.css';

// Pages
import { PageDashboard }    from './pages/PageDashboard';
import { PageAI }           from './pages/PageAI';
import { PageAutomations }  from './pages/PageAutomations';
import { PageNotifications } from './pages/PageNotifications';
import { PageNotificationCompose } from './pages/PageNotificationCompose';
import { PageSignature }    from './pages/PageSignature';
import { PageSettings }     from './pages/PageSettings';
import { PageComingSoon }   from './pages/PageComingSoon';
import { PageSupport }     from './pages/PageSupport';
import { PageUsers }        from './pages/team/PageUsers';
import { PageSubteams }     from './pages/team/PageSubteams';
import { PageCreateUser }   from './pages/team/PageCreateUser';
import { PageRequests }     from './pages/team/PageRequests';
import { PageUserAnalytics } from './pages/team/PageUserAnalytics';
import { PageUserLeads } from './pages/team/PageUserLeads';
import { PageUserEditRoute } from './pages/team/PageUserEditRoute';
import { PageLeads }        from './pages/leads/PageLeads';
import { PageMap, PageLeadsBoard, PageInsights } from './pages/leads/PageLeadsExtras';
import { PageCampaign }     from './pages/campaigns/PageCampaign';
import { PageNFC }          from './pages/nfc/PageNFC';

function AppInner() {
  const { authed, login, toast, dismissToast } = useApp();

  return (
    <BrowserRouter>
      {!authed ? (
        <>
          <div className="mesh" />
          <Routes>
            <Route path="/login" element={<PageSignIn onLogin={login} />} />
            <Route path="/signup" element={<PageSignUp />} />
            <Route path="/enterprise/set-password/:token" element={<PageSetupPassword onLogin={login} />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
          {toast && (
            <Toast
              key={toast.msg + Date.now()}
              msg={toast.msg}
              type={toast.type}
              onDone={dismissToast}
            />
          )}
        </>
      ) : (
        <Routes>
          <Route path="/" element={<AppLayout />}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<PageDashboard />} />
            <Route path="ai" element={<PageAI />} />

            <Route path="team/users" element={<PageUsers />} />
            <Route path="team/users/new" element={<PageCreateUser />} />
            <Route path="team/users/analytics" element={<PageUserAnalytics />} />
            <Route path="team/users/leads" element={<PageUserLeads />} />
            <Route path="team/users/edit" element={<PageUserEditRoute />} />
            <Route path="team/users/:id" element={<PageUsers />} />
            <Route path="team/subteams" element={<PageSubteams />} />
            <Route path="team/requests" element={<PageRequests />} />

            <Route path="leads" element={<PageLeads />} />
            <Route path="leads/map" element={<PageMap />} />
            <Route path="leads/board" element={<PageLeadsBoard />} />
            <Route path="leads/insights" element={<PageInsights />} />

            <Route path="campaigns/email" element={<PageCampaign type="email" />} />
            <Route path="campaigns/notification" element={<PageNotificationCompose />} />

            <Route path="nfc" element={<PageNFC />} />
            <Route path="automations" element={<PageAutomations />} />
            <Route path="activity" element={<PageComingSoon icon="📋" title="Activity Feed" subtitle="Track all team activity in real time" />} />
            <Route path="notifications" element={<PageNotifications />} />
            <Route path="notifications/compose" element={<PageNotificationCompose />} />
            <Route path="signature" element={<PageSignature />} />

            {/* Support */}
            <Route path="support" element={<PageSupport />} />

            {/* Settings */}
            <Route path="settings" element={<PageSettings initTab="account" />} />
            <Route path="settings/team" element={<PageSettings initTab="team" />} />
            <Route path="settings/security" element={<PageSettings initTab="security" />} />
            <Route path="settings/integrations" element={<PageSettings initTab="integrations" />} />
            <Route path="settings/notifications" element={<PageSettings initTab="notifications" />} />
            <Route path="settings/billing" element={<PageSettings initTab="billing" />} />
            <Route path="settings/api" element={<PageSettings initTab="api" />} />
            <Route path="settings/privacy" element={<PageSettings initTab="privacy" />} />

            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Route>
        </Routes>
      )}
    </BrowserRouter>
  );
}

export default function App() {
  return (
    <AppProvider>
      <AppInner />
    </AppProvider>
  );
}
